import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ApiService } from '../../../services/api.service';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { Location } from '@angular/common';

import { Page } from 'src/app/models/page.model';

import { Subscription, Subject, forkJoin } from 'rxjs';
@Component({
  selector: 'app-templatedetail',
  templateUrl: './templatedetail.page.html',
  styleUrls: ['./templatedetail.page.scss'],
})
export class TemplatedetailPage implements OnInit {
  @ViewChild('table') table: DatatableComponent;
  // @ViewChild('selectie', { static: false }) selectie: ElementRef;
  @ViewChild('searchFocus', { static: false }) ionInput: { setFocus: () => void; };
  page = new Page();
  templateForm: FormGroup;
  submitted = false;
  templateId: string;
  template: any = {};
  templates: any = {};
  showPage: boolean = false;
  detailSave: boolean = false;
  locale: any;
  searchText: any = '';
  tempLocale: any;
  templateLocale: any = [];
  TemplateType: any = [];
  rows: any = [];
  body: any;
  move: boolean = false;

  preventClick: boolean = true;
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  searchEvent: Subject<any>;
  columnsWidth: any = [];
  test: any;
  newPage: boolean = false;
  showSearchContainer: boolean = false;
  showSearch: boolean = false;

  activeVersion: any = []

  breadcrumb: any = {
    TemplateName: null
  }
  AllLocales: any = [];
  archiveIcon: string = "eye-off";
  allVersion: string = "";
  showArchive: number = 0;
  InformationBlock: Array<any> = [];
  domains: any = [];
  subscriptionList: any = [];


  constructor(private router: Router, private route: ActivatedRoute,
    private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService, private location: Location) {
    this.page.pageNumber = 0;
    this.page.size = 20;
    this.searchEvent = this._commonService.searchTextValue;
  }

  ngOnInit() {
    this.templateForm = this.formBuilder.group({
      Name: ['', Validators.required],
      Locale: [1043],
      ActiveVersion: [''],
      Description: [''],
      DocumentTemplateTypeId: ['', Validators.required],
      Active: [false],
      InformationBlockId: ['', Validators.required],
      Subscription: [''],
      Domain: [''],
      AllSubscriptions:[false]
    });
  }
  ionViewWillEnter() {
    sessionStorage.removeItem('TemplateName')
    sessionStorage.removeItem('VersionName')
    sessionStorage.removeItem('VersionId')
    this.archiveIcon = "eye-off";
    this.showSearchContainer = false;
    this.showArchive = 0;
    this.templateId = this.route.snapshot.paramMap.get('id');
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    this.detailSave = false;
    if (this.templateId == '0') {
      this.templateId = null;
      this.newPage = true;
    }

    this.getLocales();
    forkJoin([
      this.getVersion({ offset: 0 }, ''),
      this.getTemplateType(),
      this.getInformationBlock(),
      this.getSubsriptionSetting(),
      this.getDomains()
    ])
    .subscribe(t=> {
      if (this.templateId) {
        this.move = true;

        this.getTemplateDetails();
      } else {
        this._commonService.dismiss();
      }
    });

    this.template =
    {
      DocumentTemplateId: this.templateId,
      Name: "",
      Description: "",
      DocumentTemplateVersionId: "",
      DocumentTemplateTypeId: "",
      LocaleId: "",
      Active: false,
      InformationBlockId: "",
      Subscription: "",
      Domain: "",
      AllSubscriptions:false
    }
  }
  ionViewDidEnter(){
    if(this.table){
      this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
      this.table.selected = [];
      if (!this.table.element.className.includes("border-header border-footer")) this.table.element.className += " border-header border-footer";
    }

  }
  autofocusInput() {
    this.ionInput.setFocus();
    // setTimeout(() => {
    //   this.test.nativeElement.firstChild['autofocus'] = 'true';
    // }, 100);
  }

  ionViewDidLeave() {
    this.showPage = false;
    this.move = false;
    this.newPage = false;
    this.AllLocales = [];
  }

  public onLimitChange(limit: any): void {
    this.page.size = parseInt(limit, 10);
    if (this._commonService.searchText && this._commonService.searchText != '') {
      this.getVersion({ offset: 0 }, this._commonService.searchText);
    } else {
      this.getVersion({ offset: 0 }, '');
    }
  }

  async getTemplateType() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getTemplateType();
      this.TemplateType = res.body;

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        let icon;
        this.AllLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      } else {
        //test
        let icon;
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.AllLocales = JSON.parse(localStorage.domainLocales);
        localStorage.domainLocales = JSON.stringify(localeData.body);
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      }
      if (this.templateId == null) {
        this.showPage = true;
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getInformationBlock() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getModuleDetails('Module_DocumentGenerator');
      this.InformationBlock = res.body;
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  onChangeBreadcrumb() {
    this.breadcrumb.TemplateName = this.templateForm.value.Name;
  }

  onVersionChanged(event) {
    this.templateForm.patchValue({
      ActiveVersion: event
    });
  }

  async onSort(event) {
    // const sort = event.sorts[0];
    // this.page.orderBy = sort.prop.toLowerCase();
    // this.page.orderDir = sort.dir;
    // this.setPage({ offset: this.page.pageNumber }, this._commonService.searchText);
  }

  async getTemplateDetails() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getTemplateDetails(this.templateId);
      this.templates = res.body;
      sessionStorage.TemplateName = this.templates.Name;
      sessionStorage.VersionName = this.templates.VersionNumber ? this.templates.VersionNumber : '';
      sessionStorage.VersionId = this.templates.ActiveDocumentTemplateVersionId;

      this.breadcrumb.TemplateName = this.templates.Name;
      if (this.rows.length !== 0) {
        let temp = this.rows.find(el => el.DocumentTemplateVersionid == this.templates.ActiveDocumentTemplateVersionId);
        if (temp) {
          // this.template.ActiveVersion = temp.DocumentTemplateId;

          this.templateForm.patchValue({
            ActiveVersion: temp.DocumentTemplateVersionid
          });
        }
      }

      if (this.TemplateType.length !== 0) {
        let temp = this.TemplateType.find(el => el.DocumentTemplateTypeId == this.templates.DocumentTemplateTypeId);
        if (temp) {
          // this.template.ActiveVersion = temp.DocumentTemplateId;

          this.templateForm.patchValue({
            DocumentTemplateTypeId: temp.DocumentTemplateTypeId
          });
        }
      }

      if (this.InformationBlock.length !== 0) {
        let temp = this.InformationBlock.find(el => el.InformationBlockId == this.templates.InformationBlockId);
        if (temp) {
          this.templateForm.patchValue({
            InformationBlockId: temp.InformationBlockId
          });
        }
      }
      this.templates.Subscription = [];
      this.templates.Domain = [];
      if (this.templates.DomainSubscriptionId) {
        this.templates.DomainSubscriptionId.forEach(item => {
          this.templates.Subscription.push(item.DomainSubscriptionId);
        });

      }
      if (this.templates.DomainId) {
        this.templates.DomainId.forEach(item => {
          this.templates.Domain.push(item.DomainId);
        });

      }
      this.templateForm.patchValue({
        Name: this.templates.Name,
        Locale: this.templates.LocaleId,
        Description: this.templates.Description,
        Active: this.templates.Active == "1" ? true : false,
        Subscription: this.templates.Subscription,
        Domain: this.templates.Domain,
        AllSubscriptions: this.templates.AllSubscriptions == "1"? true:false
      })
      this._commonService.dismiss();
      this.templateForm.updateValueAndValidity();
      // this.body= $( "div > p" ).css( "border", "1px solid gray" );
      this.showPage = true;


    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  get f() { return this.templateForm.controls; }

  async onSubmit() {
    this.submitted = true;
    if (this.templateForm.invalid) {
      this._commonService.scrollToError();
      return;
    }
    this._commonService.presentLoading();
    try {
      // let message = this.messages.Translations.find(x => x.LocaleId == this.locale);
      // message.Body = this.messageForm.value.Body;
      // message.Subject = this.messageForm.value.Subject;

      this.template.Name = this.templateForm.value.Name;
      this.template.LocaleId = this.templateForm.value.Locale ? this.templateForm.value.Locale : null;
      this.template.DocumentTemplateVersionId = this.templateForm.value.ActiveVersion ? this.templateForm.value.ActiveVersion : null;
      this.template.Description = this.templateForm.value.Description;
      this.template.DocumentTemplateTypeId = this.templateForm.value.DocumentTemplateTypeId ? this.templateForm.value.DocumentTemplateTypeId : '';
      this.template.Active = this.templateForm.value.Active ? "1" : "0";
      this.template.InformationBlockId = this.templateForm.value.InformationBlockId ? this.templateForm.value.InformationBlockId : '';
      this.template.DomainSubscriptionId = this.templateForm.value.Subscription ? this.templateForm.value.Subscription.join() : null;
      this.template.DomainId = this.templateForm.value.Domain ? this.templateForm.value.Domain.join() : null;
      this.template.DocumentTemplateId = this.templateId ? this.templateId : null;
      this.template.AllSubscriptions = this.templateForm.value.AllSubscriptions ? "1" : "0";
      let res;
      if (this.templateId) {
        res = await this._apiService.putTemplateDetails(this.templateId, this.template);
      } else {
        res = await this._apiService.postTemplateDetails(this.template);
      }
      if (res && res.DocumentTemplateId) {
        this.templateId = res.DocumentTemplateId;
        this.newPage = false;
        this.location.replaceState('maintenance/documentgenerator/' + this.templateId);
        this.move = true;
        // this.detailSave=true;



      }

      this.breadcrumb.TemplateName = this.template.Name;
      sessionStorage.TemplateName = this.template.Name;
      this._commonService.log(this.templateId, this._commonService.LOG);
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this.submitted = false;
      setTimeout(() => {
        this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
        this.table.selected = [];
        if (!this.table.element.className.includes("border-header border-footer")) this.table.element.className += " border-header border-footer";
      }, 0);

    }
    catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
      if(error.indexOf('424') != -1) {
        this.templateForm.patchValue({
          Active: false
        });
      }
    }
  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteDocumentTemplates(this.templateId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  searchVersion(searchText) {
    this.getVersion({ offset: 0 }, searchText);
  }

  async getVersion(pageInfo, searchText) {
    if(this.templateId) {
      try {
        this._commonService.presentLoading();
        this._commonService.currentPage = pageInfo.offset;
        this.page.pageNumber = pageInfo.offset;
        this.table.offset = this.page.pageNumber;
        let res = await this._apiService.getVersions(this.templateId, searchText ? searchText : "", this.page.orderBy, this.page.orderDir, this.showArchive);
        this.page.totalElements = res.headers.get('X-Page-TotalCount');
        this.showPage = true;
        setTimeout(() => {
          this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
          this.table.selected = [];
          if (!this.table.element.className.includes("border-header border-footer")) this.table.element.className += " border-header border-footer";
          this.rows = res.body;
          this.activeVersion = this.rows.filter(f => f.IsArchive != 1)
          this._commonService.log(this.rows, this._commonService.LOG);
          this._commonService.dismiss();
        }, 100);

        await this.cssChanger();
      } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    }
  }

  cssChanger(){
    setTimeout(() => {
      let cssChange = document.querySelectorAll('ngx-datatable')[0].setAttribute('style', 'border-bottom: none !important ;');
    }, 200);

  }
  async getDomains() {
    try {
      if (localStorage.domainList) {
        this.domains = JSON.parse(localStorage.domainList);
      } else {
        let domainData = await this._apiService.getDomains('', '', '', 1, 0, true);
        this.domains = domainData.body;
        localStorage.domainList = this.domains;
        localStorage.setItem('domainList', this.domains ? JSON.stringify(this.domains) : null);
      }
      if (this.templateId == null) {
        this.showPage = true;
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }
  async getSubsriptionSetting() {
    try {
      let res = await this._apiService.getSubsriptionSettings('', localStorage.domainId, 1, '', '', '', 1, 0);
      this.subscriptionList = [...res.body];

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error.error, this._commonService.ERROR);
    }
  }
  goBack() {
    this.router.navigate(['maintenance/documentgenerator'], { replaceUrl: true })
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "delete":
        this.delete();
        break;
      case "backToList":
        this.goBack();
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;
      case "upload":
        this.openUploaderPage()


    }

  }

  onLocaleChanged(event) {
    this.templateForm.patchValue({
      Locale: event,
    })
  }
  async openUploaderPage() {
    // await this.onSubmit();
    if (this.move == true) {
      this.router.navigate(['maintenance/documentgenerator/' + this.templateId + '/upload']);
    }
  }
  onActivate(event) {
    if (event.type == 'click') {
      if (this.preventClick) {
        this.router.navigate(['maintenance/documentgenerator/' + this.templateId + '/version/' + event.row.DocumentTemplateVersionid]);
      }
    }
    if (event.type == 'checkbox') {
      this.preventClick = false;
      setTimeout(() => {
        this.preventClick = true
      }, 500)
    }
  }

  displaySearchContainer(value) {
    if (value == 'true') {
      this.showSearchContainer = false;
    } else {
      false
    }
  }

  toggleArchive() {
    if (this.archiveIcon == "eye") {
      this.archiveIcon = "eye-off";
      this.showArchive = 0;
      this.getVersion({ offset: 0 }, this.searchText);
    } else if (this.archiveIcon == "eye-off") {
      this.archiveIcon = "eye";
      this.showArchive = 1;
      this.getVersion({ offset: 0 }, this.searchText);
    }
  }

  clearField() {
    if (this.searchText != '') {
      this.searchVersion('');
    }
  }


}





